import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Grid, Row, Col} from 'react-bootstrap'
import PageTitle from "../../../common/page-title/index";
import StaffRewardSettingsForm from './staff-reward-settings-form'
//import {saveStaffRewardSettings} from '../../../../actions/staff'

import './styles.css'

class StaffRewardSettings extends Component {

  constructor(props){
    super(props);
  }

  componentWillMount() {
    //this.props.dispatch(getPpcSettings());
  }

  render(){
    return(
      <Grid bsClass="container" fluid className="staff-reward-settings">
        <Row>
          <Col lg={12}>
            <PageTitle>Staff reward settings</PageTitle>
            <StaffRewardSettingsForm />
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    fetched: state.brands.fetched,
    fetching: state.brands.fetching,
  };
};

export default connect(mapStateToProps)(StaffRewardSettings);



// WEBPACK FOOTER //
// ./src/components/admin/staff-reward/settings/index.jsx